// extracted by mini-css-extract-plugin
module.exports = {"departments":"Yt-z","departmentHeading":"Zt-z","departmentSection":"_t-z","departmentName":"au-z","departmentLink":"bu-z","expandIcon":"cu-z"};